import { render, staticRenderFns } from "./sellerpurchase.vue?vue&type=template&id=2af0c0c3&scoped=true&"
import script from "./sellerpurchase.vue?vue&type=script&lang=js&"
export * from "./sellerpurchase.vue?vue&type=script&lang=js&"
import style0 from "./sellerpurchase.vue?vue&type=style&index=0&id=2af0c0c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0c0c3",
  null
  
)

export default component.exports